import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView,
}                               from 'rewire-ui';
import classNames               from 'classnames';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import duplicateJobDialogModel  from './DuplicateJobDialogModel';
import { withStyles }           from '../utility/styles';

const styles = (_theme: Theme) => ({
  dateFieldsContainer: {
    display: 'flex',
    '& > div': {
      display: 'flex',
      flex: '1',
      '&:first-child': {
        marginRight: '20px',
      },
    },
  },
});

interface IDuplicateJobDialogProps {
}

type DuplicateJobDialogProps = WithStyle<ReturnType<typeof styles>, IDuplicateJobDialogProps>;

class DuplicateJobDialog extends React.PureComponent<DuplicateJobDialogProps> {
  constructor(props: DuplicateJobDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    duplicateJobDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    const {classes} = this.props;

    return <Observe render={() => (
      <FormView form={duplicateJobDialogModel.form} onSubmit={duplicateJobDialogModel.actionFn('save')}>
        <div className={'content'}>
          <duplicateJobDialogModel.form.field.numOfDuplicates.Editor />
        </div>
        <div className={classNames('content', classes.dateFieldsContainer)}>
          <duplicateJobDialogModel.form.field.area.Editor />
          <duplicateJobDialogModel.form.field.group.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobDialogModel.form.field.occupation.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobDialogModel.form.field.autoCreateVacancyForAbsenceReasons.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobDialogModel.form.field.removeOverlappingAssignments.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobDialogModel.form.field.assignedEmployee.Editor />
        </div>
        <div className={classNames('content', classes.dateFieldsContainer)}>
          <duplicateJobDialogModel.form.field.effectiveStart.Editor />
          <duplicateJobDialogModel.form.field.effectiveEnd.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobDialogModel.form.field.generator.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobDialogModel.form.field.cycleOffset.Editor />
        </div>
        {/* <div className={classes.calendarContainer}>
          <Observe render={() => <GeneratorCalendar model={infoPanelJobViewModel.generatorCalendarModel} classes={{calendar: classes.calendar, customEvent: classes.calendarEvent}} />} />
        </div> */}
     </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: duplicateJobDialogModel}} DraggableResizableBoxProps={{minWidth: '336px', minHeight: '430px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IDuplicateJobDialogProps>(styles, DuplicateJobDialog);
